import React from "react";

interface ActiveFilterTagsProps {
  tags: React.ReactNode[];
}

export const ActiveFilterTags = ({ tags }: ActiveFilterTagsProps) => {
  if (!tags.length) return null;

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      <span className="flex-shrink-0">Active Filters:</span>
      {tags}
    </div>
  );
};

export const activeFilterTagClassName =
  "d-flex align-items-center btn-soft-secondary btn-sm";
